export const WelcomeList = ()=> {
  const str = "Welcome to Ares Admin";
  return (
    <div style={{ position: "absolute", top: "50%", left: "50%", transform: 'translate(-15%, -100%)', fontSize: '30px' }}>{str}</div>
  );
}